<script setup>
import {Link, useForm, usePage} from '@inertiajs/inertia-vue3'
import HeroIcon from '@/Shared/HeroIcon.vue'
import {defineProps} from 'vue'

const props = defineProps({
  home: {
    type: Boolean,
    default: false,
  },
  admin: {
    type: Boolean,
    default: false,
  },
  iconName: String,
  location: String,
  urlName: String,
  urlText: String,
})
const page = usePage()
const isUrl = function (...urls) {
  let currentUrl = ''
  if (page.url.value.indexOf('/?') != -1) {
    currentUrl = page.url.value.substr(0, page.url.value.indexOf('/?'))
  } else {
    currentUrl = page.url.value.substr(1)
  }
  if (urls[0] === '') {
    return currentUrl === ''
  }
  return urls.filter((url) => currentUrl.startsWith(url)).length
}

</script>

<template>
  <Link v-if="!admin || (admin && page.props.value.is_admin)" class="group flex items-center relative sm:w-56 uppercase" :href="location">
    <div class="flex items-center transition-all 2s ease-in-out h-full sm:justify-center"
         :class="(home ? (isUrl('') || isUrl(urlName)) : (isUrl(urlName))) ? 'bg-orfGray-100 flex py-3 px-4 w-full border border-orfBlue-100 sm:border-b-0' : 'hover:bg-orfGray-100 w-full flex py-3 px-4'"
    >
      <HeroIcon :name="iconName" mini class="mr-2 w-5 h-5"
            :class="(home ? (isUrl('') || isUrl(urlName)) : (isUrl(urlName))) ? 'fill-orfRed-100' : 'fill-orfBlue-100 group-hover:fill-orfRed-100'"
      />
      <div class="text-md medium mt-1"
           :class="(home ? (isUrl('') || isUrl(urlName)) : (isUrl(urlName))) ? 'text-orfRed-100' : 'text-orfBlue-100 group-hover:text-orfRed-100'"
      >{{urlText}}
      </div>
      <div v-if="(home ? (isUrl('') || isUrl(urlName)) : (isUrl(urlName)))" class="hidden sm:flex w-full h-1 bg-orfGray-100 absolute -bottom-0.5" style="max-width: calc(100% - 2px)">
      </div>
    </div>
  </Link>
</template>
